<ng-container *ngLet="{isInternal: isInternal$ | async} as vm">
  @if (!vm.isInternal) {
    <div class="dashboard-content heading-search">
      <div class="title-of-box-hold">
        <h5 class="text-white strong my-1 ms-1">Order History</h5>
      </div>
    </div>
  }
  <div class="row mt-3">
    <div class="col-md-3">
      <find-order-panel [panelType]="'order'" (search)="searchOrders($event)" (find)="findOrder($event)"></find-order-panel>
    </div>
    <div class="col-9">
      @if (orders$ | async; as orders) {
        @if (!orders.length) {
          <table>No records found.</table>
        }
        @if (orders.length) {
          <table class="table table-striped mt-1">
            <thead>
              <tr>
                <th>Date Created</th>
                <th>Order Number</th>
                @if (vm.isInternal) {
                  <th>Customer</th>
                  <th>Rewards Number</th>
                  <th>Ship To Number</th>
                }
                <th>Branch</th>
                <th>Order Status</th>
                @if (orderHistoryDeliveryEnabled$ | async) {
                  <th id="orderHistory_th_deliveryStatus">
                    Delivery Status
                    <abbr title="Click on Order Number for additional delivery information">
                      <i class="fas fa-info-circle"></i>
                    </abbr>
                  </th>
                }
                <th>PO Number</th>
                <th>Sales Advisor Name</th>
              </tr>
            </thead>
            <tbody>
              @for (orderItem of orders; track orderItem; let i = $index) {
                <tr>
                  <td id="orderHistory_td_dateCreated_{{ i }}">
                    {{ orderItem.dateCreated | date: 'MM/dd/yyyy': 'UTC'}}
                  </td>
                  <td id="orderHistory_td_orderNumber_{{ i }}">
                    <a class="hyperlink" href="javascript:void(0)" (click)="showDetails(orderItem.orderNumber)">{{ orderItem.orderNumber }}</a>
                  </td>
                  @if (vm.isInternal) {
                    <td id="orderHistory_td_customerName_{{ i }}">
                      {{ isCashCustomer(orderItem.rewardNumber) ? "RUSH CASH CUSTOMER": orderItem.name1 }}
                    </td>
                    <td id="orderHistory_td_rewardNumber_{{ i }}">
                      {{ orderItem.rewardNumber }}
                    </td>
                    <td id="orderHistory_td_rewardNumber_{{ i }}">
                      {{ orderItem.shipToNumber }}
                    </td>
                  }
                  <td id="orderHistory_td_branch_{{ i }}">{{ orderItem.branch }}</td>
                  <td id="orderHistory_td_orderStatus_{{ i }}">
                    {{ OrderItemStatusEnum[orderItem.status] || OrderItemStatusEnum[0] | titlecase }}
                  </td>
                  @if (orderHistoryDeliveryEnabled$ | async) {
                    <td id="orderHistory_td_deliveryStatus_{{ i }}">
                      @if (isFreightShipped(orderItem) && !orderItem.freightDeliveryStatus?.length) {
                        <abbr>Shipped</abbr>
                      }
                      @if (isFreightShipped(orderItem) && orderItem.freightDeliveryStatus?.length > 0 ) {
                        {{orderItem.freightDeliveryStatus}}
                      }
                      @switch (orderItem.deliveryStatus) {
                        @case ('pickingInProgress') {
                          <abbr>Preparing Order</abbr>
                        }
                        @case ('preparing') {
                          <abbr>Preparing Order</abbr>
                        }
                        @case ('customerPickedUp') {
                          <abbr>Customer Picked Up</abbr>
                        }
                        @case ('zeroPicked') {
                          <abbr>{{vm.isInternal? 'Zero Picked': 'Call for Status'}}</abbr>
                        }
                        @case ('notApplicable') {
                          <abbr>N/A</abbr>
                        }
                        @case ('none') {
                          <abbr>N/A</abbr>
                        }
                        @case ('delivered') {
                          <abbr>Delivered</abbr>
                        }
                        @case ('enRoute') {
                          <abbr>Out For Delivery</abbr>
                        }
                        @case ('scheduled') {
                          <abbr>Scheduled</abbr>
                        }
                        @case ('notPicked') {
                          <abbr>{{vm.isInternal? 'Not Picked': 'Preparing Order'}}</abbr>
                        }
                        @case ('outForDelivery') {
                          <abbr>Out For Delivery</abbr>
                        }
                      }
                    </td>
                  }
                  <td id="orderHistory_td_poNumber_{{ i }}">
                    {{ orderItem.customerPoNumber }}
                  </td>
                  <td id="orderHistory_td_salesAdvisor_{{ i }}">
                    {{ orderItem.customerAdvisorLastName }}, {{ orderItem.customerAdvisorFirstName }}
                  </td>
                </tr>
              }
            </tbody>
          </table>
        }
      }
    </div>
  </div>
  <pagination
    [currentPage]="currentPageNumber"
    idPrefix="orderHistory"
    [totalCount]="orderCount$"
    [pageSize]="pageSize"
    (currentPageChange)="pageChange($event)">
  </pagination>
</ng-container>
